import { render } from "./QuestionTable.vue?vue&type=template&id=7b10b009&scoped=true"
import script from "./QuestionTable.vue?vue&type=script&lang=js"
export * from "./QuestionTable.vue?vue&type=script&lang=js"

import "./QuestionTable.vue?vue&type=style&index=0&id=7b10b009&lang=scss&scoped=true"

import exportComponent from "J:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b10b009"]])

export default __exports__